export const getAdminToken = () => {
  return localStorage.getItem('admin_token');
};

export const setAdminToken = (token) => {
  localStorage.setItem('admin_token', token);
};

export const getAdminRefreshToken = () => {
  return localStorage.getItem('admin_refresh_token');
};

export const setAdminRefreshToken = (token) => {
  localStorage.setItem('admin_refresh_token', token);
};

export const removeAdminToken = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_refresh_token');
  localStorage.removeItem('admin_user');
};

export const getAdminUser = () => {
  const user = localStorage.getItem('admin_user');
  return user ? JSON.parse(user) : null;
};

export const setAdminUser = (user) => {
  localStorage.setItem('admin_user', JSON.stringify(user));
};

export const isAuthenticated = () => {
  return !!getAdminToken();
};